import { getIn } from 'seamless-immutable';

const getCashback = card => {
  const inCashDiscount = getIn(card, ['minQuantity', '0', 'discount', 'value']) > 0;
  const inCashCashback = getIn(card, ['minQuantity', '0', 'cashback', 'value']);
  const inCashCashbackRate = getIn(card, ['minQuantity', '0', 'cashback', 'rate']);
  const value = inCashDiscount ? inCashCashback : getIn(card, ['cashback', 'value']);
  const rate = inCashDiscount ? inCashCashbackRate : getIn(card, ['cashback', 'rate']);

  return { value, rate };
};

const getPrice = (offer, card) => {
  if (getIn(card, ['minQuantity', '0', 'discount', 'value']) > 0) {
    return {
      price: getIn(card, ['minQuantity', '0', 'value']),
      listPrice: Math.max(card.price, offer?.salesPrice),
    };
  }

  if (getIn(card, ['discount', 'value']) > 0) {
    return {
      price: card?.price,
      listPrice: offer?.salesPrice,
    };
  }

  return {
    price: offer?.salesPrice,
    listPrice: offer?.listPrice,
  };
};

const getDiscount = (type, payment, offer) => {
  const inCashDiscount = getIn(payment, ['minQuantity', '0', 'discount'], {});
  const paymentDiscount = getIn(payment, ['discount'], {});
  const offerDiscount = getIn(offer, ['discount'], {});

  if (type === 'boleto' || type === 'pix') {
    return paymentDiscount;
  }

  if (inCashDiscount.value > 0) {
    return inCashDiscount;
  }

  if (paymentDiscount.value > 0) {
    return paymentDiscount;
  }

  return offerDiscount;
};

const getPaymentDisplay = type => {
  switch (type) {
    case 'cartaoVisa':
      return 'de crédito';
    case 'cartaoMarca':
      return 'de crédito';
    case 'boleto':
      return 'no boleto';
    case 'pix':
      return 'com pix';
    default:
      return null;
  }
};

const getInstallmentDisplay = (installmentQuantity, maxPrice, price) => {
  if (installmentQuantity > 1 && maxPrice === price) {
    return {
      installmentDisplay: `em até ${installmentQuantity}x sem juros`,
      selectedQty: installmentQuantity,
    };
  }

  return {
    installmentDisplay: 'em 1x',
    selectedQty: 1,
  };
};

export const formatPayment = (offer, type = 'cartaoVisa') => {
  const payment = offer?.[type];
  const cashback = getCashback(payment);
  const discount = getDiscount(type, payment, offer);
  const paymentDisplay = getPaymentDisplay(type);
  const { price, listPrice } = getPrice(offer, payment);
  const maxPrice = getIn(payment, ['maxQuantity', '0', 'total']);
  const installmentQuantity = getIn(payment, ['maxQuantity', '0', 'quantity']);
  const { installmentDisplay, selectedQty } = getInstallmentDisplay(installmentQuantity, maxPrice, price);

  return {
    type,
    price,
    listPrice,
    cashback,
    discount,
    installmentDisplay: installmentQuantity === 1 ? '' : installmentDisplay,
    installmentQuantity: installmentDisplay === '' ? 1 : installmentQuantity,
    selectedQty,
    paymentDisplay,
  };
};
